import { create } from 'zustand';

interface InAppHistoryState {
  depth: number;
  recordPush: () => void;
  recordPop: () => void;
}

// Tracks in-app navigation depth so the back button can be hidden when going
// back would leave the site (e.g. after a refresh or when entering via a
// direct link in a new tab). window.history.length is unreliable for this
// because it includes pre-app entries from the browser tab.
export const useInAppHistoryStore = create<InAppHistoryState>((set) => ({
  depth: 0,
  recordPush: () => set((s) => ({ depth: s.depth + 1 })),
  recordPop: () => set((s) => ({ depth: Math.max(0, s.depth - 1) })),
}));
